import { render, staticRenderFns } from "./OnlineBookingFeeForm.vue?vue&type=template&id=db16d880"
import script from "./OnlineBookingFeeForm.vue?vue&type=script&lang=js"
export * from "./OnlineBookingFeeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports